import * as React from 'react';
import FreeShippingForm from "../../components/DeliveryMethods/FreeShippingForm/FreeShippingForm";
var FreeShipping = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0431\u0435\u0437\u043F\u043B\u0430\u0442\u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(FreeShippingForm, null))))));
};
export default FreeShipping;



//////////////////
// WEBPACK FOOTER
// ./src/views/DeliveryMethods/FreeShipping.tsx
// module id = 346
// module chunks = 0